module.exports = __webpack_public_path__ + "static/img/D1000.99c19d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/device/D1000/D1000.png
// module id = c3mP
// module chunks = 0